// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__EAoqb","box":"WorkspacesBox_box__-V4Zd","node":"WorkspacesBox_node__2x5DT"};